import { render } from "./PropertySubdivision.vue?vue&type=template&id=19175d80&scoped=true"
import script from "./PropertySubdivision.vue?vue&type=script&lang=js"
export * from "./PropertySubdivision.vue?vue&type=script&lang=js"

import "./PropertySubdivision.vue?vue&type=style&index=0&id=19175d80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19175d80"]])

export default __exports__